import { Link } from '../routing';
import { track, EVENTS } from '../utils/analytics';

// The two lenses on the same collection (this month's suppliers): what is still
// owed, and what has already been paid. They are separate ROUTES rather than
// local state so each view has its own shareable/bookmarkable URL, the browser
// back button behaves, and each page keeps its own columns, filter bar and
// drill-down. The date range is shared across both via utils/sharedDateRange.
//
// Why tabs and not a status filter: a filter promises "fewer rows"; these views
// differ in their COLUMNS (לתשלום shows amount owed + due date; שולם shows paid
// / unpaid split, payment method and last payment date). Filtering the suppliers
// table to שולם gives the right rows with columns that cannot answer the
// question — which is why the old סטטוס תשלום filter was removed in favour of
// this control.
//
// Rendered as <nav> + <Link aria-current>, NOT role="tablist"/role="tab". The
// ARIA tabs pattern describes buttons that swap panels within a page and
// implies arrow-key navigation between them; these navigate to a different URL
// and have no tabpanel, so claiming that role told screen readers something
// untrue. Real anchors also give cmd/middle-click "open in a new browser tab",
// which is genuinely useful for comparing the two views side by side.
//
// Desktop styles them as folder tabs docked to the data card; ≤720px they
// become a full-width segmented pill. That is entirely CSS — see index.css.
const TABS = [
  { key: 'unpaid', label: 'לתשלום', path: '/suppliers' },
  { key: 'paid',   label: 'היסטורית תשלומים', path: '/suppliers/paid' },
];

// Set on a tab click and read once by the destination page, so it can report
// whether the view was reached deliberately or landed on directly (bookmark,
// refresh, back button). Module-level rather than state: it has to survive the
// unmount/mount of a route change.
let lastEntry = null;
export function consumeViewEntry() {
  const entry = lastEntry;
  lastEntry = null;
  return entry || 'direct';
}

export default function PaymentViewTabs({ active }) {
  const handleClick = (tab, e) => {
    // Clicking the active tab is not a view change — no navigation, and no
    // event, so the analytics count stays a clean measure of switching intent.
    if (tab.key === active) { e.preventDefault(); return; }
    lastEntry = 'tab_click';
    track(EVENTS.PAYMENT_VIEW_TAB_CLICKED, { tab: tab.key, from: active });
  };

  return (
    <nav className="view-tabs" aria-label="תצוגת תשלומים">
      {TABS.map(tab => {
        const isActive = tab.key === active;
        return (
          <Link
            key={tab.key}
            to={tab.path}
            className={`view-tab${isActive ? ' is-active' : ''}`}
            aria-current={isActive ? 'page' : undefined}
            onClick={(e) => handleClick(tab, e)}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
